export const CREATE_INCOME_RECORD = "CREATE_INCOME_RECORD";
export const FETCH_INCOME_RECORDS = "FETCH_INCOME_RECORDS";
export const FETCH_INCOME_RECORD = "FETCH_INCOME_RECORD";
export const EDIT_INCOME_RECORD = "EDIT_INCOME_RECORD";
export const DELETE_INCOME_RECORD = "DELETE_INCOME_RECORD";
